/* eslint-disable */
import React, { useState } from "react";
import { MATERIAL_SUB_OPTIONS } from "./shared";
import { MultiImageUpload, SearchableSelect, generateUniqueSku } from "./utils";

// ── FrameForm ─────────────────────────────────────────────────────────────────
export function FrameForm({ data, set, fields, inputSt, lblSt, accentColor, borderColor, isNew, allItems, canAddBrands=false, onUploadingChange }) {
  const [showAdv, setShowAdv] = useState(false);
  const [skuLoading, setSkuLoading] = useState(false);
  // Local state to track "Other" brand — avoids React batching race condition
  // where SearchableSelect calls onChange + setOpen(false) in same render cycle,
  // causing data.brand === "Other" to not trigger the conditional re-render reliably.
  const [isOtherBrand, setIsOtherBrand] = useState(() => data.brand === "Other");
  const getOpts = (key) => (fields.find(f=>f.key===key)||{options:[]}).options;

  // Async SKU generation — queries DB for true uniqueness
  const updateSkuForBrand = async (brandName) => {
    if (!brandName || brandName === "Other") { set("sku", ""); return; }
    setSkuLoading(true);
    try {
      const sku = await generateUniqueSku(brandName);
      set("sku", sku);
    } catch(e) {
      console.error("SKU generation failed:", e);
    }
    setSkuLoading(false);
  };

  const sel = (key, label, options, opts={}) => {
    const isMat = key === "material", isBrand = key === "brand";
    return (
      <div key={key} style={opts.full?{gridColumn:"1/-1"}:{}}>
        <label style={lblSt}>{label}</label>
        <select value={data[key]||""} onChange={e=>{ set(key,e.target.value); if(isBrand) updateSkuForBrand(e.target.value); if(isMat) set("materialDetail",""); }} style={inputSt}>
          <option value="">Select...</option>
          {options.map(o=><option key={o}>{o}</option>)}
        </select>
      </div>
    );
  };
  const txt = (key, label, opts={}) => (
    <div key={key} style={opts.full?{gridColumn:"1/-1"}:{}}>
      <label style={lblSt}>{label}</label>
      <input type={opts.type||"text"} value={data[key]||""} onChange={e=>set(key,e.target.value)} style={inputSt}
        onFocus={e=>e.target.style.borderColor=accentColor} onBlur={e=>e.target.style.borderColor=borderColor}/>
    </div>
  );
  const materialDetailOptions = MATERIAL_SUB_OPTIONS[data.material] || [];
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:'var(--space-lg)'}}>
      <div><label style={lblSt}>Frame Photos (up to 10)</label><MultiImageUpload images={data.images||[]} onChange={imgs=>set("images",imgs)} onUploadingChange={onUploadingChange} /></div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:'var(--space-md)'}}>
        <div style={{ gridColumn:"1/-1" }}>
          <label style={lblSt}>Brand <span style={{ color:"#ef4444" }}>*</span></label>
          <SearchableSelect
            value={data.brand||""}
            onChange={v=>{
              setIsOtherBrand(v === "Other");
              set("brand", v);
              set("brandCustom", "");
              updateSkuForBrand(v);
            }}
            options={(() => {
              const opts = getOpts("brand").slice().filter(o => o === "Other" ? canAddBrands : true).sort((a,b) => a.localeCompare(b));
              const idx = opts.indexOf("Other");
              if (idx > 0) { opts.splice(idx, 1); opts.unshift("Other"); }
              return opts;
            })()}
            placeholder="Search brand..."
            style={inputSt}
          />
          {isOtherBrand && (
            <div style={{ marginTop:'var(--space-sm)'}}>
              <label style={{ ...lblSt, color:"var(--gold)" }}>New Brand Name <span style={{ color:"#A32D2D" }}>*</span></label>
              <div style={{ display:"flex", gap:'var(--space-sm)', alignItems:"center" }}>
                <div style={{ width:14, height:14, borderRadius:'var(--radius-xs)', background:"var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <span style={{ color:"var(--card-bg)", fontSize:'var(--text-2xs)', fontWeight:'var(--weight-bold)', lineHeight:1 }}>+</span>
                </div>
                <input
                  type="text"
                  value={data.brandCustom||""}
                  onChange={e=>{ set("brandCustom",e.target.value); updateSkuForBrand(e.target.value); }}
                  placeholder="Enter new brand name..."
                  style={{ ...inputSt, flex:1, borderColor:"var(--gold)" }}
                  autoFocus
                />
                <span style={{ fontSize:'var(--text-2xs)', color:"var(--gold)", letterSpacing:"0.5px", fontWeight:'var(--weight-medium)' }}>NEW</span>
              </div>
              <div style={{ fontSize:'var(--text-2xs)', color:"var(--text-muted)", letterSpacing:"0.3px", marginTop:'var(--space-xs)'}}>Brand will be added to the list for all users</div>
            </div>
          )}
        </div>
        {sel("frameCategory","Optic / Sunglasses",getOpts("frameCategory"))}
        {sel("origin","Origin",getOpts("origin"))}
        {sel("material","Material",getOpts("material"))}
        {data.material && materialDetailOptions.length > 0 ? (
          <div><label style={lblSt}>Material Detail</label>
          <select value={data.materialDetail||""} onChange={e=>set("materialDetail",e.target.value)} style={inputSt}>
            <option value="">Select...</option>{materialDetailOptions.map(o=><option key={o}>{o}</option>)}</select></div>
        ) : <div/>}
        {sel("gender","Gender",getOpts("gender"))}
        <div/>
        {sel("shape1","Shape 1",getOpts("shape1"))}{sel("shape2","Shape 2",getOpts("shape2"))}{sel("shape3","Shape 3",getOpts("shape3"))}<div/>
        {sel("status","Status",getOpts("status"))}{sel("assignedTo","Assigned To",getOpts("assignedTo"))}
        <div>
          <label style={lblSt}>Received Date</label>
          <input type="month" value={data.receivedDate||""} onChange={e=>set("receivedDate",e.target.value)} style={inputSt}
            onFocus={e=>e.target.style.borderColor=accentColor} onBlur={e=>e.target.style.borderColor=borderColor}/>
        </div>
        <div/>
        {txt("developmentOrder","Development Order Ref",{full:true})}
      </div>
      {/* Collapsible advanced fields */}
      {(()=>{return (<>
          <button type="button" onClick={()=>setShowAdv(p=>!p)}
            style={{ width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between", background:showAdv?"#f1f5f9":"transparent", border:"var(--border-emphasis) dashed #e2e8f0", borderRadius:'var(--radius-lg)', padding:"var(--space-sm) var(--space-lg)", cursor:"pointer", color:"#64748b", fontSize:'var(--text-xs)', fontWeight:'var(--weight-semi)' }}>
            <span>⚙ Advanced Fields (SKU · Location · Price · Color)</span>
            <span style={{ fontSize:'var(--text-base)' }}>{showAdv?"▲":"▼"}</span>
          </button>
          {showAdv && (
            <div style={{ display:"flex", flexDirection:"column", gap:'var(--space-md)', padding:"var(--space-lg) var(--space-lg)", background:"#f8fafc", borderRadius:'var(--radius-lg)', border:"var(--border-med) solid #e2e8f0" }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:'var(--space-md)'}}>
                <div>
                  <label style={lblSt}>SKU / Ref. Code <span style={{ fontSize:'var(--text-2xs)', color:"#6366f1", fontWeight:'var(--weight-bold)', marginLeft:'var(--space-xs)'}}>AUTO</span></label>
                  <div style={{ position:"relative" }}>
                    <input type="text" value={skuLoading ? "Generating..." : (data.sku||(isNew&&!data.brand?"Select brand first...":""))} readOnly
                      style={{ ...inputSt, background:"#f0f0ee", color:data.sku?"#1e293b":"#94a3b8", cursor:"default", fontFamily:"monospace", fontWeight:'var(--weight-bold)', paddingRight:'var(--space-4xl)'}}/>
                    <span style={{ position:"absolute", right:10, top:"50%", transform:"translateY(-50%)", fontSize:'var(--text-base)' }}>{skuLoading ? "⏳" : "🔒"}</span>
                  </div>
                </div>
                {txt("location","Warehouse Location")}{txt("color","Color / Finish")}{txt("price","Price")}
              </div>
            </div>
          )}
      </>);
      })()}
      <div><label style={lblSt}>Notes</label><textarea value={data.notes||""} onChange={e=>set("notes",e.target.value)} rows={2} style={{...inputSt,resize:"vertical"}}/></div>
    </div>
  );
}
